module.exports = __webpack_public_path__ + "static/media/Zam-Zamac1920.c2aea929.jpg";